import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const LocationSearchBox = styled(Box)`
  width: 100%;
`;